import {
  Card,
  SkeletonBodyText,
  TextContainer,
  Layout
} from '@superops/ui-design-system';
import React from 'react';
import styled from 'styled-components';
import { times } from 'lodash';

const SkeletonWrapper = styled.div`
  background-color: white;
  padding: 20px;
  .no-shadow-card {
    margin-left: 10px;
    margin-bottom: 10px;
    box-shadow: none;
    border: 0.1rem solid #f0f0f6;
    border-radius: 10px;
  }
`;

const ListLoading = () => {
  const count = Math.floor(window.innerHeight / 120);
  return (
    <SkeletonWrapper>
      <Layout>
        <Layout.Section>
          {times(count, () => (
            <div className="no-shadow-card" key={count}>
              <Card sectioned>
                <TextContainer>
                  <Layout>
                    <Layout.Section>
                      <SkeletonBodyText lines={2} />
                    </Layout.Section>
                  </Layout>
                </TextContainer>
              </Card>
            </div>
          ))}
        </Layout.Section>
      </Layout>
    </SkeletonWrapper>
  );
};

export default ListLoading;
